import { Pipe, PipeTransform } from '@angular/core';
import { LogbookRecordWarning } from '@fleet-beat/api';

@Pipe({
  name: 'hasAnyWarningOfType',
  pure: true,
})
export class HasAnyWarningOfTypePipe implements PipeTransform {
  transform(warnings: LogbookRecordWarning[] | null | undefined, type: string | string[]): boolean {
    if (!warnings?.length) {
      return false;
    }
    const typesArray = Array.isArray(type) ? type : [type];
    return warnings.some((warning: LogbookRecordWarning) => typesArray.includes(warning.type));
  }
}
